module.exports = "<div class=technique level={{level}}><div class=title><slot></slot></div><div class=progress><div class=progress-bar role=progressbar aria-valuenow=0 aria-valuemin=0 aria-valuemax=100></div></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Technique.vue
 ** module id = 229
 ** module chunks = 0
 **/